import { useEffect, useState } from "react";
import axios from 'axios';

export default function NewsletterSection() {
  const [newsletter, setNewsletter] = useState([]);
  const API_BASE = import.meta.env.VITE_API_BASE_URL;

  useEffect(() => {
    const fetchSubscribers = async () => {
      try {
        const res = await axios.get(`${API_BASE}subscribers`);
        setNewsletter(res.data);
      } catch (error) {
        console.error("Failed to fetch subscribers:", error);
      }
    };
    fetchSubscribers();
  }, []);

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Newsletter Subscribers</h2>
      <ul>
        {newsletter.map((sub, idx) => (
          <li key={idx} className="mb-2 border-b pb-1">{sub.email}</li>
        ))}
      </ul>
    </div>
  );
}
